import React, { useMemo } from "react";
import { UiDataPartType } from "@juristic/types/stream/ai/data_events";
import { ToolHookEventType } from "@juristic/types/stream/ai/tool_hooks";
import { QuestionLine } from "../cards/QuestionLine";
import { ToolConfirmationCard } from "../cards/ToolConfirmationCard";
import { WordExecCard } from "../cards/WordExecCard";
import { findCardInterruption } from "../utils/cardInterruption";
export function ToolHookPart({ part, ctx }) {
    const { message, toolDecisions } = ctx;
    const resolvedDecisions = useMemo(()=>message.parts.reduce((map, p)=>{
            if (p.type === UiDataPartType.ToolHook && p.data.type === ToolHookEventType.ConfirmationResolved) {
                map[p.data.toolCallId] = p.data.approved;
            }
            return map;
        }, {
            ...toolDecisions ?? {}
        }), [
        message.parts,
        toolDecisions
    ]);
    const choiceSelection = useMemo(()=>{
        if (part.data.type !== ToolHookEventType.ChoiceRequest) return undefined;
        const { toolCallId: id } = part.data;
        const resolved = message.parts.find((p)=>p.type === UiDataPartType.ToolHook && p.data.type === ToolHookEventType.ChoiceResolved && p.data.toolCallId === id);
        if (resolved?.type === UiDataPartType.ToolHook && resolved.data.type === ToolHookEventType.ChoiceResolved) {
            const { data: settled } = resolved;
            return {
                cancelled: settled.cancelled,
                optionId: settled.optionId,
                customText: settled.customText,
                answers: settled.answers
            };
        }
        return ctx.choiceAnswers?.[id];
    }, [
        part.data,
        message.parts,
        ctx.choiceAnswers
    ]);
    const { data } = part;
    if (data.type === ToolHookEventType.ChoiceRequest) {
        return /*#__PURE__*/ React.createElement(QuestionLine, {
            request: data,
            selection: choiceSelection,
            interrupted: choiceSelection ? false : findCardInterruption(message, data.toolCallId)
        });
    }
    if (data.type === ToolHookEventType.ClientToolRequest) {
        const { toolCallId: id } = data;
        const isResolved = message.parts.some((p)=>p.type === UiDataPartType.ToolHook && p.data.type === ToolHookEventType.ClientToolResolved && p.data.toolCallId === id);
        return /*#__PURE__*/ React.createElement(WordExecCard, {
            key: `${ctx.messageId}-word-exec-${id}`,
            request: data,
            isResolved: isResolved,
            interrupted: isResolved ? false : findCardInterruption(message, id)
        });
    }
    const toolCallId = data.type === ToolHookEventType.ConfirmationRequest ? data.toolCallId : undefined;
    const isApproved = toolCallId !== undefined ? resolvedDecisions[toolCallId] : undefined;
    const interrupted = toolCallId !== undefined && isApproved === undefined && findCardInterruption(message, toolCallId);
    const isResponding = toolCallId !== undefined ? ctx.respondingToolIds?.has(toolCallId) : undefined;
    const onRespond = async (id, approved)=>await ctx.onToolConfirmationResponse?.(id, approved) ?? false;
    if (data.type === ToolHookEventType.ConfirmationRequest) {
        return /*#__PURE__*/ React.createElement(ToolConfirmationCard, {
            key: `${ctx.messageId}-tool-confirm-${data.toolCallId}`,
            request: data,
            decision: isApproved,
            interrupted: interrupted,
            responding: isResponding,
            onRespond: onRespond
        });
    }
    return null;
}
